import * as Dialog from '@radix-ui/react-dialog';

import { styled } from '@lichtblick/styled';
import { Colors } from '@lichtblick/theme';

export const Overlay = styled(Dialog.Overlay)`
  align-items: flex-start;
  background: ${Colors.darkBlue}CC;
  display: flex;
  height: 100vh;
  justify-content: center;
  overflow-y: auto;
  padding: var(--spacing-xs) 0;
  position: fixed;
  top: 0;
  width: 100vw;
  z-index: var(--z-index-modal-backdrop);

  @keyframes overlayShow {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  &[data-state='open'] {
    animation: overlayShow 150ms ease-in-out;
  }

  @keyframes overlayHide {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
    }
  }

  &[data-state='closed'] {
    animation: overlayHide 150ms ease-in-out;
  }
`;

export const CloseButton = styled(Dialog.Close)<{ $shouldSticky?: boolean }>`
  color: ${Colors.blue[100]};
  cursor: pointer;
  position: ${({ $shouldSticky }) => ($shouldSticky ? 'sticky' : 'absolute')};
  ${({ $shouldSticky }) => ($shouldSticky ? 'left: 100%' : 'right: var(--spacing-xs)')};
  top: var(--spacing-xs);
  z-index: var(--z-index-raised1);
`;
